// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import App from './App.vue';
import core from '@bmp-vue/core';
import DatePicker from '../src/components/Datepicker.vue';
import datadogRumPlugin from '../src/plugins/datadogRum';

Vue.config.productionTip = false;
Vue.use(datadogRumPlugin);

var controllers = require.context('@/controllers', true, /\.js$/);
const paths = require('@/plugins/router/paths').default
const theme = require('@/plugins/vuetify/theme').default;

Vue.use(core, {
  controllers,
  paths,
  theme,
  defaultViews: false,
  carregaEnums: false,
  mount: (options) => {
    Vue.component('DatePicker', DatePicker);

    new Vue({
      ...options,
      render: h => h(App)
    }).$mount('#app');
  }
});
